import styled from 'styled-components';

export default styled.div`
  position: relative;
  margin: 0 0 14px;
  width: 100%;
`;
